import { AmountValidator } from '@src/common/fields/AmountValidator';
import { PositiveFloatField } from '@src/permitField/PermitFields';

export class UsdRateField extends PositiveFloatField {
  public static fieldName = 'usdRate' as const;
  public static validator = AmountValidator.required();
}

export class CadRateField extends PositiveFloatField {
  public static fieldName = 'cadRate' as const;
  public static validator = AmountValidator.required();
}
